"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var convertListToArray_1 = __importDefault(require("../___utils/convertListToArray"));
var filterList_1 = __importDefault(require("../___utils/filterList"));
var groupList_1 = __importDefault(require("../___utils/groupList"));
var isType_1 = require("../___utils/isType");
var limitList_1 = __importDefault(require("../___utils/limitList"));
var reverseList_1 = __importDefault(require("../___utils/reverseList"));
var searchList_1 = __importDefault(require("../___utils/searchList"));
var sortList_1 = __importDefault(require("../___utils/sortList"));
var props_1 = require("../props");
var uiFunctions_1 = require("./uiFunctions");
var withList = function (List) {
    var DataList = function (props) {
        var list = props.list, limit = props.limit, reversed = props.reversed, renderWhenEmpty = props.renderWhenEmpty, // render/list related props
        filterBy = props.filterBy, // filter props
        group = props.group, groupBy = props.groupBy, groupOf = props.groupOf, showGroupSeparatorAtTheBottom = props.showGroupSeparatorAtTheBottom, groupReversed = props.groupReversed, groupSeparatorAtTheBottom = props.groupSeparatorAtTheBottom, groupSortedCaseInsensitive = props.groupSortedCaseInsensitive, groupSortedDescending = props.groupSortedDescending, groupSorted = props.groupSorted, groupSortedBy = props.groupSortedBy, // group props
        sortBy = props.sortBy, sortDesc = props.sortDesc, sort = props.sort, sortCaseInsensitive = props.sortCaseInsensitive, sortGroupBy = props.sortGroupBy, sortGroupDesc = props.sortGroupDesc, sortGroupCaseInsensitive = props.sortGroupCaseInsensitive, sortDescending = props.sortDescending, // sort props
        search = props.search, searchBy = props.searchBy, searchOnEveryWord = props.searchOnEveryWord, searchTerm = props.searchTerm, searchCaseInsensitive = props.searchCaseInsensitive, searchableMinCharactersCount = props.searchableMinCharactersCount, searchMinCharactersCount = props.searchMinCharactersCount;
        var renderList = convertListToArray_1.default(list);
        if (renderList.length === 0) {
            return uiFunctions_1.renderBlank(renderWhenEmpty);
        }
        if (reversed) {
            renderList = reverseList_1.default(renderList);
        }
        if (!isType_1.isNil(limit)) {
            var _a = ("" + limit).split(','), from = _a[0], to = _a[1];
            renderList = limitList_1.default(renderList, from, to);
        }
        if (filterBy) {
            renderList = filterList_1.default(renderList, filterBy);
        }
        if (searchTerm || (search && search.term)) {
            var searchOptions = __assign(__assign({}, props_1.defaultProps.search), search);
            renderList = searchList_1.default(renderList, {
                by: searchOptions.by
                    || searchBy
                    || '0',
                caseInsensitive: searchOptions.caseInsensitive
                    || searchCaseInsensitive,
                everyWord: searchOptions.onEveryWord
                    || searchOptions.everyWord // deprecated
                    || searchOnEveryWord,
                term: searchOptions.term
                    || searchTerm,
                minCharactersCount: searchOptions.searchableMinCharactersCount // deprecated
                    || searchOptions.minCharactersCount
                    || searchMinCharactersCount
                    || searchableMinCharactersCount // deprecated
                    || 3
            });
        }
        var sortOptions = __assign(__assign({}, props_1.defaultProps.sort), sort);
        if (sortOptions.by || sortBy || (isType_1.isBoolean(sort) && sort)) {
            renderList = sortList_1.default(renderList, {
                caseInsensitive: sortOptions.caseInsensitive
                    || sortCaseInsensitive,
                descending: sortOptions.descending
                    || sortDescending
                    || sortDesc,
                by: sortOptions.by
                    || sortBy
            });
        }
        var groupOptions = __assign(__assign({}, props_1.defaultProps.group), group);
        if (groupOptions.by || groupBy || groupOf || groupOptions.of || groupOptions.limit) {
            var groupingOptions = {
                by: groupOptions.by
                    || groupBy,
                limit: groupOptions.of
                    || groupOf
                    || groupOptions.limit,
                reversed: groupOptions.reversed
                    || groupReversed
            };
            var gList_1 = groupList_1.default(renderList, groupingOptions);
            renderList = gList_1.groupLists
                .reduce(function (newGList, aGroup, idx) {
                if (groupSorted || groupOptions.sorted || groupSortedBy || groupOptions.sortedBy
                    || groupOptions.sortBy || sortGroupBy || sortOptions.groupBy // deprecated
                ) {
                    aGroup = sortList_1.default(aGroup, {
                        caseInsensitive: groupSortedCaseInsensitive
                            || groupOptions.sortedCaseInsensitive
                            || groupOptions.sortCaseInsensitive // deprecated
                            || sortGroupCaseInsensitive // deprecated
                            || sortOptions.groupCaseInsensitive,
                        descending: groupSortedDescending
                            || groupOptions.sortedDescending
                            || groupOptions.sortDescending // deprecated
                            || sortGroupDesc,
                        by: groupSortedBy
                            || groupOptions.sortedBy
                            || groupOptions.sortBy // deprecated
                            || sortGroupBy // deprecated
                    });
                }
                var separator = ['___list-separator', gList_1.groupLabels[idx], aGroup];
                if (groupOptions.separatorAtTheBottom || groupSeparatorAtTheBottom || showGroupSeparatorAtTheBottom) {
                    return __spreadArrays(newGList, aGroup, [separator]);
                }
                return __spreadArrays(newGList, [separator], aGroup);
            }, []);
        }
        return (react_1.default.createElement(List, __assign({}, props, { list: renderList })));
    };
    return react_1.memo(react_1.forwardRef(function (props, ref) { return (react_1.default.createElement(DataList, __assign({}, props, { __forwarededRef: ref }))); }));
};
exports.default = withList;
//# sourceMappingURL=withList.js.map